import { useMemo, useState } from "react";
import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./ui/command";
import { Check, ChevronsUpDown } from "lucide-react";

// 48 kalemlik aranabilir, ana kategoriye göre gruplu dropdown
export const KalemCombobox = ({ kalemler, value, onChange, placeholder = "Gider kalemi seçin", testid = "kalem-combobox" }) => {
  const [open, setOpen] = useState(false);

  const grouped = useMemo(() => {
    const map = new Map();
    (kalemler || []).forEach((k) => {
      if (!map.has(k.ana_kategori)) map.set(k.ana_kategori, []);
      map.get(k.ana_kategori).push(k);
    });
    return Array.from(map.entries());
  }, [kalemler]);

  const secili = (kalemler || []).find((k) => k.id === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="h-12 w-full justify-between font-normal"
          data-testid={testid}
        >
          <span className={`truncate ${secili ? "" : "text-muted-foreground"}`}>
            {secili ? `${secili.hesap_kodu ? secili.hesap_kodu + " • " : ""}${secili.kalem_adi}` : placeholder}
          </span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] min-w-[300px] p-0 bg-card" align="start">
        <Command
          filter={(itemValue, search) =>
            itemValue.toLocaleLowerCase("tr-TR").includes(search.toLocaleLowerCase("tr-TR")) ? 1 : 0
          }
        >
          <CommandInput placeholder="Kalem ara…" data-testid={`${testid}-search`} />
          <CommandList className="max-h-72">
            <CommandEmpty>Kalem bulunamadı.</CommandEmpty>
            {grouped.map(([kategori, items]) => (
              <CommandGroup key={kategori} heading={kategori}>
                {items.map((k) => (
                  <CommandItem
                    key={k.id}
                    value={`${k.hesap_kodu} ${k.kalem_adi} ${kategori}`}
                    onSelect={() => {
                      onChange(k.id === value ? "" : k.id);
                      setOpen(false);
                    }}
                    className="min-h-[40px] cursor-pointer"
                    data-testid={`${testid}-item`}
                  >
                    <Check className={`mr-2 h-4 w-4 shrink-0 ${value === k.id ? "opacity-100 text-[hsl(var(--accent))]" : "opacity-0"}`} />
                    <span className="text-xs text-muted-foreground mr-1.5 tabular-nums">{k.hesap_kodu}</span>
                    <span className="truncate">{k.kalem_adi}</span>
                  </CommandItem>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
